<template>
    <li :class="{ 'multi-select-option': true, selected: isSelected }">
        <button type="button" @click="toggle">
            <div class="multi-select-option__check" v-if="showCheck">
                <img :src="isSelected ? '/img/icons/checkbox-checked.svg' : '/img/icons/checkbox-unchecked.svg'" />
            </div>
            <div class="multi-select-option__content">
                <slot :value="value" :text="text" :data="data">{{ text }}</slot>
            </div>
        </button>
    </li>
</template>

<script>
export default {
    props: {
        value: undefined,
        text: undefined,
        data: {
            type: Object
        },
        selected: {
            type: Boolean,
            default: false
        },
        showCheck: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isSelected: this.selected
        }
    },
    computed: {
        optionData() {
            return this.data ? this.data : { value: this.value, text: this.text };
        }
    },
    watch: {
        selected: function(newState) {
            this.isSelected = selected;
        }
    },
    created() {
        this.$parent.$emit('option-created', this);

        if(this.isSelected) {
            this.$parent.$emit('selected', this.optionData);
        }
    },
    destroyed() {
        this.$parent.$emit('option-destroyd', this);
    },
    methods: {
        select() {
            this.isSelected = true;
            this.$parent.$emit('selected', this.optionData);
        },
        deselect() {
            this.isSelected = false;
            this.$parent.$emit('deselected', this.optionData);
        },
        toggle() {
            if(this.isSelected) {
                this.deselect();
            } else {
                this.select();
            }
        }
    }
}
</script>